import { CallCenterPartnerEnum } from '@/enums/crm/call-center/call-center-partner.enum';
import { BusinessModelEnum } from '@/enums/crm/business-model.enum';

export default class SettingsModel {
  flagHabilitaNovoPainelCliente!: boolean;

  flagConverteProspectIGS!: boolean;

  flagIntegraClienteAposConversaoProspect!: boolean;

  flagUsaSegundaViaBoletos!: boolean;

  flagExibeColunasAdicionaisInfoFinanceira!: boolean;

  flagIntegracaoSintegraAtivo!: boolean;

  urlCrmApp!: string;

  flagObrigaClassificacaoFechamentoConversa!: boolean;

  flagObrigaDescricaoFechamentoConversa!: boolean;

  flagTornarCnpjProspectObrigatorio!: boolean;

  flagTornarRazaoSocialProspectOpcional!: boolean;

  flagTornarFantasiaProspectObrigatorio!: boolean;

  flagUtilizaWhatsapp!: boolean;

  flagUtilizaAgenda!: boolean;

  flagExcluiAgenda!: boolean;

  loggedUserType!: number;

  restringeVisualizacaoPorHierarquia?: boolean;

  visualizaTudo?: boolean;

  flagPermiteExcluirAnexos!: boolean;

  flagMostraChatsUsuariosRootVisaoGeral!: boolean;

  flagObrigaClassificacaoEmail!: boolean;

  flagHabilitaMenuVisitas!: boolean;

  flagPermiteEditarParticularidades!: boolean;

  flagHabilitaMenuClientesCidadeProspect!: boolean;

  flagCongelaPreenchimentoSintegra!: boolean;

  flagNaoPreencheTelefoneEmailProspectSintegra!: boolean;

  flagEmailProspectObrigatorio!: boolean;

  flagTelefoneProspectObrigatorio!: boolean;

  flagPermiteCadastroAtendenteChave!: boolean;

  flagMenuVendasColecaoErp!: boolean;

  flagRemoveObrigatorioRepresentanteAgenda360!: boolean;

  flagApresentaRepresentantesInativosAgenda360!: boolean;

  flagIntegracaoClienteUnicoAtivo!: boolean;

  flagPermiteClientesSituacao99Crm360!: boolean;

  realizaEnvioCampanhasInformativos!: boolean;

  flagEnviaContatoErp!: boolean;

  tituloColunaCoringa1Pedidos!: string;

  modeloNegocio?: number | null;

  get isTextileBusinessModel(): boolean {
    return this.modeloNegocio === BusinessModelEnum.Textile.valueOf();
  }

  tituloCoringa1Cliente?: string | null;

  tituloCoringa2Cliente?: string | null;

  tituloCoringa3Cliente?: string | null;

  tituloCoringa4Cliente?: string | null;

  flagGeoCodificacao!: boolean;

  urlAcessoExterno!: string;

  urlAcessoInterno!: string;

  urlAcessoGeo360!: string;

  flagWhatsApp360Ativo!: boolean;

  isCRMEvoTalks!: boolean;

  isWhatsAppEvoTalksAtivo!: boolean;

  flagUtilizaEvoTalks!: boolean;

  urlBaseEvoTalks!: string;

  flagUtilizaTelefonia!: boolean;

  partnerCodeCallCenter!: number;

  quantidadeGestoesPainelRelacionamento!: number;

  flagAudioInsightsAtivo!: boolean;

  get isCloudTalkPartner(): boolean {
    return this.partnerCodeCallCenter === CallCenterPartnerEnum.CloudTalk.valueOf();
  }

  flagAbreParticularidadesPainelCliente!: number;

  flagExibirProspectFVPadrao!: boolean;

  flagIdentificaContatoMaisCinquenta!: number;

  whatsappDirecionamentoUrl!: string;

  flagHabilitaAbrirProcessoNoDialog!: boolean;

  flagAbrirProcessoNovaGuiaPainelRelacionamento!: number;

  flagPermiteAlterarAtendenteChaveEmMassa!: boolean;

  flagIntegracaoRDStation!: boolean;

  flagValidaCompraMenorNaJusticacao!: boolean;

  usaChatVendas!: boolean;

  numeroCanalChatVendas!: string;

  isEvoTalksEGeoChatHabilitado!: boolean;

  moduloGeochatAtivo!: boolean;

  flagDepartamentoObrigatorioAgenda!: boolean;

  flagExpandirParticularidadesPorPadrao!: boolean | null;

  flagObrigatorioPreenchimentoDescricaoCriarAgenda!: boolean | null;

  flagObrigatorioPreenchimentoObservacaoInternaCriarAgenda!: boolean | null;
}
